"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = splitProps;
/**
 * Utility to split props based on an array of keys
 */
function splitProps(props, keys) {
  var matchedProps = {};
  var remainingProps = {};
  var propKeys = Object.keys(props);

  for (var i = 0; i < propKeys.length; i++) {
    var propKey = propKeys[i];
    var propValue = props[propKey];

    if (keys.includes(propKey)) {
      matchedProps[propKey] = propValue;
    } else {
      remainingProps[propKey] = propValue;
    }
  }

  return { matchedProps: matchedProps, remainingProps: remainingProps };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9zcGxpdC1wcm9wcy5qcyJdLCJuYW1lcyI6WyJzcGxpdFByb3BzIiwicHJvcHMiLCJrZXlzIiwibWF0Y2hlZFByb3BzIiwicmVtYWluaW5nUHJvcHMiLCJwcm9wS2V5cyIsIk9iamVjdCIsImkiLCJsZW5ndGgiLCJwcm9wS2V5IiwicHJvcFZhbHVlIiwiaW5jbHVkZXMiXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUd3QkEsVTtBQUh4Qjs7O0FBR2UsU0FBU0EsVUFBVCxDQUFvQkMsS0FBcEIsRUFBMkJDLElBQTNCLEVBQWlDO0FBQzlDLE1BQU1DLGVBQWUsRUFBckI7QUFDQSxNQUFNQyxpQkFBaUIsRUFBdkI7QUFDQSxNQUFNQyxXQUFXQyxPQUFPSixJQUFQLENBQVlELEtBQVosQ0FBakI7O0FBRUEsT0FBSyxJQUFJTSxJQUFJLENBQWIsRUFBZ0JBLElBQUlGLFNBQVNHLE1BQTdCLEVBQXFDRCxHQUFyQyxFQUEwQztBQUN4QyxRQUFNRSxVQUFVSixTQUFTRSxDQUFULENBQWhCO0FBQ0EsUUFBTUcsWUFBWVQsTUFBTVEsT0FBTixDQUFsQjs7QUFFQSxRQUFJUCxLQUFLUyxRQUFMLENBQWNGLE9BQWQsQ0FBSixFQUE0QjtBQUMxQk4sbUJBQWFNLE9BQWIsSUFBd0JDLFNBQXhCO0FBQ0QsS0FGRCxNQUVPO0FBQ0xOLHFCQUFlSyxPQUFmLElBQTBCQyxTQUExQjtBQUNEO0FBQ0Y7O0FBRUQsU0FBTyxFQUFDUCwwQkFBRCxFQUFlQyw4QkFBZixFQUFQO0FBQ0QiLCJmaWxlIjoic3BsaXQtcHJvcHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIFV0aWxpdHkgdG8gc3BsaXQgcHJvcHMgYmFzZWQgb24gYW4gYXJyYXkgb2Yga2V5c1xuICovXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzcGxpdFByb3BzKHByb3BzLCBrZXlzKSB7XG4gIGNvbnN0IG1hdGNoZWRQcm9wcyA9IHt9XG4gIGNvbnN0IHJlbWFpbmluZ1Byb3BzID0ge31cbiAgY29uc3QgcHJvcEtleXMgPSBPYmplY3Qua2V5cyhwcm9wcylcblxuICBmb3IgKGxldCBpID0gMDsgaSA8IHByb3BLZXlzLmxlbmd0aDsgaSsrKSB7XG4gICAgY29uc3QgcHJvcEtleSA9IHByb3BLZXlzW2ldXG4gICAgY29uc3QgcHJvcFZhbHVlID0gcHJvcHNbcHJvcEtleV1cblxuICAgIGlmIChrZXlzLmluY2x1ZGVzKHByb3BLZXkpKSB7XG4gICAgICBtYXRjaGVkUHJvcHNbcHJvcEtleV0gPSBwcm9wVmFsdWVcbiAgICB9IGVsc2Uge1xuICAgICAgcmVtYWluaW5nUHJvcHNbcHJvcEtleV0gPSBwcm9wVmFsdWVcbiAgICB9XG4gIH1cblxuICByZXR1cm4ge21hdGNoZWRQcm9wcywgcmVtYWluaW5nUHJvcHN9XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/ui-box/lib/utils/split-props.js
// module id = 115
// module chunks = 0